export default {"src":"/reise/pakkereiser/_next/static/media/EmptyState.6a678ae9.svg","height":243,"width":277,"blurWidth":0,"blurHeight":0};